export default function CourseSchedule() {
  return (
    <div style={{ padding: 24 }}>
      <h2>课程表</h2>
      <p style={{ color: '#999' }}>功能开发中...</p>
    </div>
  )
}
